// Silence a warning "Symbol.observable as defined by Redux and Redux DevTools do not match."
// eslint-disable-next-line
import Symbol_observable from "symbol-observable";

import React from "react";
import ReactDOM from "react-dom";
import "./assets/stylesheets/fonts.scss";
import App from "./components/App";

if (localStorage.getItem("axe-tools") === "true") {
  const axe = require("@axe-core/react");
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(React.createElement(App), document.getElementById("root"));
